import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { CustomerType, CustomerState } from './customerTypes'

const initialState: CustomerState = {
  selectedCustomer: null,
  customers: []
}

const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    setSelectedCustomer(
      state,
      action: PayloadAction<CustomerState['selectedCustomer']>
    ) {
      state.selectedCustomer = action.payload
    },
    setCustomers(state, action: PayloadAction<CustomerType[]>) {
      state.customers = action.payload
    }
  }
})

export const customerReducer = customerSlice.reducer
